/**
 * @file paddle hack topic
 * @author wanzhongyun
 */
import { RightOutlined } from '@ant-design/icons';
import { RootObject, Content2, Module } from '../../type';

import './style.less';


const HackTopic = (props: RootObject['taskList']) => {

    const {
        titleImg,
        subTitle,
        content,
        topicLink,
        topicName
    } = props;


    return (
        <div className='paddle-hack-topic-f-wrapper'>
            <div className='paddle-hack-topic-f-wrapper-content'>
                <img className='paddle-hack-topic-f-title' src={titleImg} alt='' />
                <div className='paddle-hack-topic-f-sub-title'>{subTitle ?? ''}</div>
                {/* 任务模块 */}
                <div className='paddle-hack-topic-f-module-wrapper'>

                    {
                        content?.map((cV: Content2, cIndex) => {
                            return (
                                <div className='paddle-hack-topic-f-module' key={cIndex}>
                                    <div className={cV.titleJump ? 'topic-module-title topic-module-title-hover' : 'topic-module-title topic-module-title-disable'} onClick={() => cV.titleJump ? window.open(cV.titleJump) : undefined}>
                                        <div className='topic-module-title-img' style={{ backgroundImage: `url(${cV?.titleBackImg ?? ''})` }}>
                                        </div>
                                        <div className='topic-module-title-hover-img' style={{ backgroundImage: `url(${cV?.hoverTitleBackImg ?? ''})` }}>
                                        </div>
                                        <div className='topic-module-title-content'>
                                            <div className='topic-module-title-content-desc'>
                                                {
                                                    cV?.title ?? ''
                                                }
                                            </div>
                                        </div>

                                    </div>
                                    <div className='paddle-hack-topic-f-module-list'>

                                        {
                                            cV?.modules.map((mV: Module, index) => {
                                                return (
                                                    <div className='module-list-block' key={index}>
                                                        <div className='module-list-block-title'>
                                                            {
                                                                mV.moduleTitle ?? ''
                                                            }
                                                        </div>
                                                        <div className='module-list-block-desc'>
                                                            {
                                                                mV.moduleDescribe ?? ''
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        {/* <div className='paddle-hack-topic-f-module-list-line'></div> */}
                                    </div>
                                </div>
                            )
                        })
                    }




                </div>
            </div>
            <div className='paddle-hack-topic-f-all-link'>
                <a href={topicLink} target='_blank' rel="noreferrer" >{topicName ?? ''}<RightOutlined className='paddle-pilot-rights-detail-link-icon' /></a>
            </div>
        </div>
    );
};

export default HackTopic;